import { cloneDeep, get, set } from 'lodash';
import { NACHWEIS_POSITION_STATUS } from 'src/lib/constants/constant';

// import Schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import { getFieldNamefromDataPath } from 'src/utils/helper';
const MA_P = MittelabrufSchema.attributes;
const BJ_P = MA_P.Foerderantrag.schema.attributes.Bewilligung_Jahresaufteilung.schema.attributes;
const NP_P = NachweisPositionSchema.attributes;

export const executeEpzMAFormulas = (application: any) => {
	let appCopy = cloneDeep(application);
	let result: any = [];

	// let calculatedGesamt = calculateGesamt(appCopy);
	// result.push(...calculatedGesamt);
	// for (let ele of calculatedGesamt) {
	// 	set(appCopy, get(ele, 'path'), get(ele, 'value'));
	// }
	let calculatedFoerderung = calculateFoerderung(appCopy);
	result.push(...calculatedFoerderung);
	for (let ele of calculatedFoerderung) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	return result;
};

export const calculateGesamt = (application: any) => {
	// let result: any = [];
	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
	const getAusgabenByStatus = (status: string) => {
		const nachweisposition = (nachweispositionen as any[]).find((eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
		return Number(get(nachweisposition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	};
	const angefalleneAusgaben = getAusgabenByStatus(NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const anfallendeAusgaben = getAusgabenByStatus(NACHWEIS_POSITION_STATUS.geplant);
	const gesamt = angefalleneAusgaben + anfallendeAusgaben;

	// result.push({
	// 	path: MA_P.Epz_Gesamt.path,
	// 	value: !isNaN(gesamt) ? gesamt.toFixed(2) : 0,
	// });

	return gesamt;
};

export const calculateFoerderung = (application: any) => {
	let result: any = [];
	const haushaltsjahr = Number(get(application, MA_P.Allgemein_Haushaltsjahr.path, 0));
	const bewilligungJahresaufteilung = get(application, MA_P.Foerderantrag.schema.attributes.Bewilligung_Jahresaufteilung.path, []);
	const jahresEintrag = bewilligungJahresaufteilung.find(
		(curr: any) => Number(get(curr, getFieldNamefromDataPath(BJ_P.Projektjahr.path), 0)) === haushaltsjahr,
	);
	const foerderquote =
		Number(get(jahresEintrag, getFieldNamefromDataPath(BJ_P.Foerderquote_403741.path), 0)) ||
		Number(get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Foerderquote_Gesamt.path, 0)) ||
		0;
	const projektausgabenGesamt = Number(calculateGesamt(application)) || 0;
	const zuwendungAnteilig = projektausgabenGesamt * (foerderquote / 100);
	const foerderung = Number(get(application, MA_P.Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung.path, 0)) || 0;
	const bisherAbgerufeneMittel = Number(get(application, MA_P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, 0)) || 0;
	const maxAbrufbareFoerderung = Math.max(0, foerderung - bisherAbgerufeneMittel);
	const berechneteMaxFoerderung = Math.max(0, Math.min(zuwendungAnteilig - bisherAbgerufeneMittel, maxAbrufbareFoerderung));
	result.push(
		{
			path: MA_P.Zuwendung_Anteilig_Gesamt.path,
			value: !isNaN(zuwendungAnteilig) ? zuwendungAnteilig.toFixed(2) : 0,
		},
		{
			path: MA_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path,
			value: !isNaN(zuwendungAnteilig) ? zuwendungAnteilig.toFixed(2) : 0,
		},
		{
			path: MA_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path,
			value: !isNaN(berechneteMaxFoerderung) ? berechneteMaxFoerderung.toFixed(2) : 0,
		},
	);

	return result;
};
